
import React from 'react';
import styled from 'styled-components';
import HeaderOne from '../parts/HeaderOne';
import { GetPublicProfile200Response } from "../../../api/v1";
import goldBadge from "../../assets/images/badges/gold.png";
import silverBadge from "../../assets/images/badges/silver.png";
import bronzeBadge from "../../assets/images/badges/bronze.png";
import Text from "../parts/Text";
import Image from "../parts/Image";
import HeaderTwo from "../parts/HeaderTwo";

type publicProfileProps = {
  username: string;
  imageUrl: string;
  badges: GetPublicProfile200Response['badges'];
}

const badgesImage = {
  gold: goldBadge,
  silver: silverBadge,
  bronze: bronzeBadge
};

const PublicProfileStyle = styled.div`
  background: none;
  margin: 0 auto 10px;
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const BadgesStyle = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
    margin-left: -4px;
    
  img {
    width: 64px;
  }
`;

const BadgeStyle = styled.div`
  text-align: center;
`;

const PublicProfileForm: React.FC<publicProfileProps> = ({ username, imageUrl, badges }) => {
  return (
    <PublicProfileStyle>
      <HeaderOneStyle>プロフィール</HeaderOneStyle>
      <Image src={String(imageUrl)} alt='プロフィール画像' width='100px' height='100px' mb='10px'/>
      <HeaderTwo>ユーザー情報</HeaderTwo>
      <Text size='16px' mb='20px'>{username}</Text>
      {badges.length > 0 &&
        <>
          <HeaderTwo>獲得バッチ</HeaderTwo>
          <BadgesStyle>
            {badges.map((badge, index) => {
              return (
                <BadgeStyle key={index}>
                  <img src={badgesImage[badge.type]} alt={`${badge}-badge`}/>
                  <Text size='12px'>{badge.name}</Text>
                </BadgeStyle>
              );
            })}
          </BadgesStyle>
        </>
      }
    </PublicProfileStyle>
  );
};

export default PublicProfileForm;
